import { render, staticRenderFns } from "./ExternalAssetsView.vue?vue&type=template&id=c73cca02&scoped=true"
import script from "./ExternalAssetsView.vue?vue&type=script&lang=js"
export * from "./ExternalAssetsView.vue?vue&type=script&lang=js"
import style0 from "./ExternalAssetsView.vue?vue&type=style&index=0&id=c73cca02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73cca02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c73cca02')) {
      api.createRecord('c73cca02', component.options)
    } else {
      api.reload('c73cca02', component.options)
    }
    module.hot.accept("./ExternalAssetsView.vue?vue&type=template&id=c73cca02&scoped=true", function () {
      api.rerender('c73cca02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/external-assets/ExternalAssetsView.vue"
export default component.exports